export * from "mongodb-stitch-browser-core";
export * from "mongodb-stitch-browser-services-mongodb-remote";
//# sourceMappingURL=index.js.map